import React from 'react';
import { motion } from 'framer-motion';

const LINE = 'rgba(245,245,242,0.2)';
const LINE_STRONG = 'rgba(245,245,242,0.4)';
const ACCENT = '#7C8CFF';

const fade = (delay: number) => ({
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1, delay, ease: [0.22, 1, 0.36, 1] as const } },
});

const strategyLines = [
    [40, 60, 140, 110], [60, 160, 150, 90], [30, 240, 160, 200],
    [90, 320, 180, 260], [50, 400, 170, 340],
];

const gridCols = 6;
const gridRows = 5;

const TransitionVisual = () => (
    <svg viewBox="0 0 1200 480" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <motion.g initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }} variants={fade(0)}>
            {strategyLines.map(([x1, y1, x2, y2], i) => (
                <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={LINE} strokeWidth={1.2} strokeLinecap="round" />
            ))}
            {strategyLines.map(([x1, y1], i) => (
                <circle key={`d-${i}`} cx={x1} cy={y1} r={3} fill={LINE_STRONG} />
            ))}
        </motion.g>

        <motion.line
            x1={220} y1={240} x2={640} y2={240}
            stroke={ACCENT} strokeWidth={2}
            initial={{ pathLength: 0 }}
            whileInView={{ pathLength: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        />
        <motion.circle
            cx={640} cy={240} r={6} fill={ACCENT}
            initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 1.2 }}
        />

        <motion.g initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }} variants={fade(0.5)}>
            {Array.from({ length: gridCols }).map((_, col) =>
                Array.from({ length: gridRows }).map((_, row) => {
                    const x = 720 + col * 70;
                    const y = 100 + row * 65;
                    const highlight = col === gridCols - 1 && row === 0;
                    return (
                        <rect
                            key={`${col}-${row}`}
                            x={x} y={y} width={46} height={46}
                            fill="none"
                            stroke={highlight ? ACCENT : LINE}
                            strokeWidth={highlight ? 1.5 : 1}
                        />
                    );
                })
            )}
        </motion.g>
    </svg>
);

export default TransitionVisual;
